var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL3Reserve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6389_20752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98928 0.744629V14.6762C7.98928 15.2635 8.11037 15.6683 8.35255 15.8907C8.59473 16.113 8.99254 16.2252 9.54598 16.2271C9.83111 16.2309 10.116 16.211 10.3966 16.1678C10.5856 16.1407 10.7687 16.0896 10.9398 16.0161V17.8461C10.5925 17.982 10.2274 18.0822 9.85231 18.1446C9.44873 18.2152 9.03784 18.2511 8.62586 18.2515C7.38004 18.2515 6.46409 17.9776 5.878 17.4299C5.29191 16.8821 4.99924 16.0365 5 14.8931V0.744629H7.98928Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6243 0.788739C22.9253 0.788739 24.0183 0.995096 24.9033 1.40781C25.7883 1.82052 26.4592 2.37149 26.9158 3.06072C27.3691 3.73271 27.6082 4.52487 27.602 5.33394C27.6151 5.92952 27.5119 6.52197 27.2981 7.07848C27.1138 7.54277 26.8449 7.96925 26.5048 8.33643C26.1949 8.66916 25.8216 8.93726 25.4064 9.12512C25.0329 9.30115 24.6295 9.40613 24.2171 9.43466V9.46437C25.168 9.46207 26.0901 9.7891 26.8249 10.3893C27.1873 10.692 27.4788 11.0698 27.6792 11.4962C27.9008 11.9814 28.0102 12.5098 27.9993 13.0426C27.9993 14.1156 27.7195 15.0405 27.1599 15.8173C26.5688 16.6194 25.7657 17.243 24.8398 17.6188C23.8535 18.0422 22.7198 18.2543 21.4387 18.2552C19.8729 18.2552 18.4955 17.9163 17.3066 17.2386C16.1177 16.561 15.246 15.5251 14.6914 14.1309L17.6802 12.8272C17.9036 13.7351 18.3253 14.4367 18.9455 14.932C19.5657 15.4273 20.3959 15.6749 21.4362 15.6749C22.0579 15.6925 22.6763 15.579 23.2507 15.3418C23.7188 15.1439 24.1208 14.818 24.4101 14.4021C24.6899 13.9792 24.8336 13.4817 24.8223 12.9757C24.8223 12.128 24.5529 11.5217 24.0141 11.1569C23.4753 10.7921 22.645 10.6101 21.5234 10.6109C21.3573 10.6109 21.1743 10.6158 20.9742 10.6257C20.7699 10.6369 20.567 10.6517 20.364 10.6716V8.33891C20.5155 8.35899 20.6681 8.36933 20.821 8.36986H21.2482C22.3275 8.36986 23.1258 8.16351 23.643 7.75079C24.1602 7.33808 24.4193 6.70622 24.4201 5.8552C24.4201 5.06692 24.166 4.45528 23.6579 4.02028C23.1498 3.58528 22.4313 3.36778 21.5022 3.36778C20.5458 3.36778 19.7986 3.57992 19.2606 4.00419C18.7226 4.42845 18.3718 5.03473 18.2083 5.82301L15.2804 4.76193C15.5245 3.94666 15.9643 3.20263 16.5619 2.59394C17.1786 1.98097 17.9303 1.51895 18.7575 1.24437C19.6797 0.933614 20.6481 0.779985 21.6218 0.789975",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6389_20752",
    x: 0,
    y: 0.744629,
    width: 33,
    height: 27.5105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6389_20752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6389_20752",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL3Reserve);
export default __webpack_public_path__ + "static/media/l3-reserve.16542018a32703282373a20357b0d011.svg";
export { ForwardRef as ReactComponent };